import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Squeeze from './Squeeze';
import { useLocation, useNavigate } from 'react-router-dom';

const PlaylistTableView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const songs = location.state?.songs || [];
  const playlistName = location.state?.playlistName || 'Playlist';

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleBack = () => {
    navigate('/builder');
  };

  return (
    <div>
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <div className="container">
          <Button variant="secondary" onClick={handleBack} className="mb-3">
            ← Back to Loading
          </Button>
          <h1>Filter or pick songs from {playlistName}</h1>
          <Squeeze 
            list={songs} 
            closingModal={handleBack}
          />
        </div>
      )}
    </div>
  );
};

export default PlaylistTableView;
